import { render, staticRenderFns } from "./RequestCalls.vue?vue&type=template&id=c9f33a10&"
import script from "./RequestCalls.vue?vue&type=script&lang=js&"
export * from "./RequestCalls.vue?vue&type=script&lang=js&"
import style0 from "./RequestCalls.vue?vue&type=style&index=0&id=c9f33a10&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports